(function () {
  'use strict';

  function assetDirectory(value) {
    var source = value || '';
    var slash = source.lastIndexOf('/');
    return slash >= 0 ? source.slice(0, slash + 1) : '';
  }

  function initScene(section) {
    if (section.sceneCleanup) section.sceneCleanup();
    var wheel = section.querySelector('#sceneWheel');
    var list = section.querySelector('#sceneList');
    var image = section.querySelector('#sceneImage');
    var count = section.querySelector('#sceneCount');
    if (!wheel || !list || !image) return;

    var defaults = [
      ['Hiking', 'scene-hike.jpg'],
      ['Casual', 'scene-leisure.jpg'],
      ['Training', 'scene-training.jpg'],
      ['Trekking', 'scene-summit.jpg'],
      ['Kids', 'scene-kids.jpg']
    ];
    var assetBase = assetDirectory(wheel.getAttribute('data-asset-base') || image.getAttribute('src'));
    var scenes = defaults.map(function (scene, index) {
      return {
        label: wheel.getAttribute('data-scene-label-' + (index + 1)) || scene[0],
        href: 'scene-' + scene[0].toLowerCase() + '.html',
        source: wheel.getAttribute('data-scene-image-' + (index + 1)) ||
          (index === 0 ? image.getAttribute('src') : '') || assetBase + scene[1]
      };
    });
    var config = section.querySelector('[data-scenes-json]');
    if (config) { try { scenes = JSON.parse(config.textContent); } catch (error) { return; } }
    if (!scenes.length) { list.replaceChildren(); return; }
    scenes = scenes.map(function (scene) {
      var desktopSource = scene.desktopSource || scene.source || '';
      var mobileSource = scene.mobileSource || desktopSource;
      return Object.assign({}, scene, { desktopSource: desktopSource, mobileSource: mobileSource, source: desktopSource });
    });
    var controller = new AbortController();
    var signal = controller.signal;
    var pos = 0;
    var target = 0;
    var raf = null;
    var last = 0;
    var drag = null;
    var timer = null;
    var currentIndex = -1;
    var suppressClickUntil = 0;
    var disposed = false;
    var motionQuery = (window.SaguaroMotion ? window.SaguaroMotion() : matchMedia('(prefers-reduced-motion: reduce)'));
    // Match the existing V31 mobile layout breakpoint so gesture mode and
    // layout mode stay in sync.
    var mobileQuery = window.matchMedia('(max-width: 700px)');
    var reduceMotion = motionQuery.matches;
    var preloadCache = {};
    var layers = [];
    var ready = [];
    var requested = [];
    var originalSource = image.getAttribute('src');
    var originalStyle = image.getAttribute('style');
    var originalAlt = image.getAttribute('alt');
    var scrollRoot = section.closest('[data-m02-story]');
    var scrollStage = scrollRoot && scrollRoot.querySelector('.m02-scene-screen, .scene-terrain-screen');
    var scrollDriven = !!(scrollRoot && scrollStage);
    var scrollDirty = false;
    var scrollStep = 0;
    var scrollTravel = 0;
    var rowSize = 48;
    var sizeObserver = null;
    var preloadObserver = null;

    function sourceFor(scene) { return isMobileMode() ? scene.mobileSource : scene.desktopSource; }
    function refreshSources() {
      scenes.forEach(function (scene, index) {
        scene.source = sourceFor(scene);
        ready[index] = false;
        requested[index] = false;
      });
      image.alt = (scenes[Math.round(target)] || scenes[0]).label;
      requestImage(0);
      requestImage(Math.round(target));
      start();
    }

    scenes.forEach(function (scene, index) {
      var layer = index === 0 ? image : image.cloneNode(false);
      if (index) {
        layer.removeAttribute('id');
        layer.removeAttribute('src');
        layer.removeAttribute('srcset');
        layer.removeAttribute('sizes');
        layer.removeAttribute('loading');
        layer.setAttribute('aria-hidden', 'true');
        layer.alt = '';
        layer.classList.add('scene-image-layer--secondary');
        layers[index - 1].insertAdjacentElement('afterend', layer);
      }
      layer.classList.add('scene-image-layer');
      layer.style.transition = 'none';
      layer.style.opacity = index === 0 ? '1' : '0';
      layer.style.zIndex = '0';
      layers.push(layer);
      ready.push(index === 0);
    });
    list.replaceChildren();

    function isMobileMode() { return mobileQuery.matches; }

    function rowHeight() {
      var first = list.firstElementChild;
      var fontSize = first ? parseFloat(window.getComputedStyle(first).fontSize) : 0;
      return Math.max(48, (isFinite(fontSize) ? fontSize : 0) * 1.3);
    }

    function keepActiveVisible(index) {
      if (!isMobileMode()) return;
      var active = list.children[index];
      if (!active || !wheel.scrollTo) return;
      var left = active.offsetLeft - (wheel.clientWidth - active.offsetWidth) / 2;
      var max = Math.max(0, wheel.scrollWidth - wheel.clientWidth);
      wheel.scrollTo({ left: Math.max(0, Math.min(max, left)), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    // Decode once before a layer is revealed. A failed replacement leaves the
    // nearest usable photograph visible instead of exposing the background.
    function preload(source) {
      if (!preloadCache[source]) {
        preloadCache[source] = new Promise(function (resolve, reject) {
          var candidate = new Image();
          candidate.onload = function () {
            if (candidate.decode) candidate.decode().catch(function () {}).then(function () { resolve(source); });
            else resolve(source);
          };
          candidate.onerror = reject;
          candidate.src = source;
        });
      }
      return preloadCache[source];
    }

    function requestImage(index) {
      if (!Number.isInteger(index) || index < 0 || index >= scenes.length) return;
      if (ready[index] || requested[index]) return;
      requested[index] = true;
      var requestedSource = scenes[index].source;
      if(!requestedSource){layers[index].removeAttribute('src');layers[index].style.visibility='hidden';ready[index]=true;return;}
      layers[index].style.visibility='';
      preload(requestedSource).then(function (source) {
        if (disposed || ready[index] || scenes[index].source !== requestedSource) return;
        layers[index].src = source;
        ready[index] = true;
        start();
      }).catch(function () {});
    }

    function paintImages(value) {
      value = Math.max(0, Math.min(scenes.length - 1, Number.isFinite(value) ? value : target));
      var lower = Math.floor(value);
      var upper = Math.min(scenes.length - 1, lower + 1);
      requestImage(lower);
      requestImage(upper);
      var fraction = value - lower;
      if (!ready[lower] || !ready[upper]) {
        var closest = -1;
        ready.forEach(function (loaded, index) {
          if (loaded && (closest < 0 || Math.abs(index - value) < Math.abs(closest - value))) closest = index;
        });
        lower = upper = Math.max(0, closest);
        fraction = 0;
      }
      layers.forEach(function (layer, index) {
        // The lower layer stays opaque. Only its adjacent layer fades over it,
        // so scroll reversal is immediate and no black gap can open mid-blend.
        var opacity = index === lower ? 1 : index === upper ? fraction : 0;
        var text = opacity.toFixed(4);
        if (layer.style.opacity !== text) layer.style.opacity = text;
      });
    }

    scenes.forEach(function (scene, index) {
      var button = document.createElement('a');
      button.href = scene.href;
      button.className = 'scene-btn' + (index === 0 ? ' active' : '');
      button.textContent = scene.label;
      button.setAttribute('aria-label', 'Scopri ' + scene.label);
      if (scene.blockId) { button.setAttribute('data-block-id', scene.blockId); }
      button.tabIndex = 0;
      button.addEventListener('click', function (event) {
        if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); return; }
        if (isMobileMode() && Math.round(target) !== index) { event.preventDefault(); selectScene(index, true); }
      }, { signal: signal });
      list.appendChild(button);
    });

    function frame(now) {
      if (disposed) return;
      if (scrollDirty) readScroll();
      var dt = Math.max(0, Math.min((now - last) / 1000, 0.05));
      var k = reduceMotion || (scrollDriven && !isMobileMode()) ? 1 : 1 - Math.exp(-dt / 0.14);
      last = now;
      pos += (target - pos) * k;
      if (Math.abs(target - pos) < 0.001) pos = target;
      var mobile = isMobileMode();
      var tilt = 6 * Math.PI / 180;
      var radius = rowSize / tilt;
      Array.prototype.forEach.call(list.children, function (element, index) {
        var selected = index === Math.round(pos);
        element.classList.toggle('active', selected);
        element.tabIndex = 0;
        if (mobile) {
          element.style.transform = 'none';
          element.style.opacity = selected ? '1' : '0.8';
          element.style.filter = 'none';
          return;
        }
        var distance = index - pos;
        var angle = Math.max(-Math.PI / 2, Math.min(Math.PI / 2, distance * tilt));
        var y = radius * Math.sin(angle);
        var x = -radius * (1 - Math.cos(angle));
        var absoluteDistance = Math.abs(distance);
        element.style.transform = 'translate(' + x.toFixed(2) + 'px, calc(' + y.toFixed(2) + 'px - 50%)) rotate(' + (angle * 180 / Math.PI).toFixed(2) + 'deg)';
        element.style.opacity = Math.max(0.08, 1 - absoluteDistance * 0.22);
        element.style.filter = reduceMotion ? 'none' : 'blur(' + Math.min(2.6, absoluteDistance * 1.2).toFixed(2) + 'px)';
      });
      paintImages(reduceMotion ? Math.round(pos) : pos);
      raf = pos !== target ? window.requestAnimationFrame(frame) : null;
    }

    function start() {
      if (raf !== null || disposed) return;
      last = window.performance.now();
      raf = window.requestAnimationFrame(frame);
    }

    function apply(value, snap) {
      target = Math.max(0, Math.min(scenes.length - 1, value));
      if (snap) target = Math.round(target);
      var index = Math.round(target);
      if (index !== currentIndex) {
        currentIndex = index;
        if (scrollRoot) scrollRoot.setAttribute('data-active-scene', String(index));
        if (count) count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(scenes.length).padStart(2, '0');
        image.alt = scenes[index].label;
        keepActiveVisible(index);
      }
      start();
    }

    // The document supplies the travel, just like M04. Sticky positioning keeps
    // the existing scene + terrain composition still while that travel is used.
    function readScroll() {
      scrollDirty = false;
      if (disposed || !scrollDriven || isMobileMode() || !scrollStep) return;
      var elapsed = Math.max(0, Math.min(scrollTravel, -scrollRoot.getBoundingClientRect().top));
      var value = Math.min(scenes.length - 1, elapsed / scrollStep);
      scrollRoot.setAttribute('data-scene-progress', (elapsed / Math.max(scrollTravel, 1)).toFixed(4));
      if (reduceMotion) value = Math.round(value);
      if (Math.abs(value - target) > .0001) apply(value, false);
    }

    function scheduleScroll() {
      scrollDirty = true;
      start();
    }

    function measureScroll() {
      rowSize = rowHeight();
      if (!scrollDriven || disposed) return;
      if (isMobileMode()) {
        scrollStep = 0;
        scrollRoot.classList.remove('is-ready');
        scrollRoot.style.removeProperty('--m02-scroll-height');
        scrollRoot.removeAttribute('data-scene-progress');
        return;
      }
      var height = scrollStage.getBoundingClientRect().height;
      var amount = parseFloat(scrollRoot.getAttribute('data-scroll-step'));
      scrollStep = height * Math.max(16, Math.min(200, isFinite(amount) ? amount : 38)) / 100;
      // Four transitions and a short final hold; no extra full empty step.
      scrollTravel = Math.max(0, scenes.length - 1) * scrollStep + Math.min(120, height * 0.12);
      scrollRoot.style.setProperty('--m02-scroll-height', (height + scrollTravel) + 'px');
      scrollRoot.setAttribute('data-scroll-step-px', scrollStep.toFixed(2));
      scrollRoot.classList.add('is-ready');
      scheduleScroll();
    }

    function selectScene(value, snap) {
      var next = Math.max(0, Math.min(scenes.length - 1, value));
      if (snap) next = Math.round(next);
      if (scrollDriven && !isMobileMode() && scrollStep) {
        var top = window.scrollY + scrollRoot.getBoundingClientRect().top;
        // Keep direct choices in sync with scroll, so the next swipe continues
        // from the chosen scene rather than returning to an earlier one.
        window.scrollTo({ top: top + next * scrollStep, behavior: 'instant' });
      }
      apply(next, snap);
    }

    wheel.addEventListener('wheel', function (event) {
      if (scrollDriven) return;
      if (isMobileMode()) return;
      var delta = event.deltaMode === 1 ? event.deltaY * 24 : event.deltaY;
      if (!delta || (target <= 0 && delta < 0) || (target >= scenes.length - 1 && delta > 0)) return;
      event.preventDefault();
      apply(target + Math.max(-1, Math.min(1, delta / (140 * (Number(section.dataset.scrollStep) || 38) / 38))), false);
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () { apply(target, true); }, 140);
    }, { passive: scrollDriven, signal: signal });

    wheel.addEventListener('pointerdown', function (event) {
      if (isMobileMode()) return;
      if (!event.isPrimary || event.button !== 0) return;
      drag = { x: event.clientX, y: event.clientY, start: target, moved: false, axis: null, captured: false, id: event.pointerId };
    }, { signal: signal });
    wheel.addEventListener('pointermove', function (event) {
      if (!drag || drag.id !== event.pointerId) return;
      var dy = event.clientY - drag.y;
      if (Math.abs(dy) > 4) drag.moved = true;
      if (drag.moved && !drag.captured && wheel.setPointerCapture) {
        wheel.setPointerCapture(event.pointerId);
        drag.captured = true;
      }
      if (drag.moved) selectScene(drag.start - dy / rowHeight(), false);
    }, { signal: signal });

    function endDrag(event) {
      if (!drag || drag.id !== event.pointerId) return;
      if (drag.moved) {
        suppressClickUntil = Date.now() + 350;
        if (!isMobileMode() || drag.axis === 'x') selectScene(target, true);
      }
      if (drag.captured && wheel.hasPointerCapture && wheel.hasPointerCapture(event.pointerId)) wheel.releasePointerCapture(event.pointerId);
      drag = null;
    }
    wheel.addEventListener('pointerup', endDrag, { signal: signal });
    wheel.addEventListener('pointercancel', endDrag, { signal: signal });
    wheel.addEventListener('lostpointercapture', function (event) {
      // A button loses its implicit touch capture when the wheel takes over.
      // Only losing the wheel's own capture should end the active gesture.
      if (event.target === wheel) drag = null;
    }, { signal: signal });
    // One mobile gesture surface covers photograph and labels. Vertical scroll remains native.
    var mobileSurface = section.querySelector('.scene-wheel-wrap');
    var gesture = null;
    var lastTouchAt = 0;
    function swipeStart(x, y) { gesture = { x: x, y: y, start: Math.max(0, currentIndex), dx: 0, axis: null }; }
    function swipeMove(x, y, event) {
      if (!gesture) return;
      var dx = x - gesture.x, dy = y - gesture.y;
      if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 10) gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (gesture.axis === 'x') { gesture.dx = dx; if (event.cancelable) event.preventDefault(); }
    }
    function swipeEnd(event) {
      if (gesture && event?.changedTouches?.length === 1) swipeMove(event.changedTouches[0].clientX, event.changedTouches[0].clientY, event);
      if (!gesture) return;
      if (gesture.axis === 'x' && Math.abs(gesture.dx) >= 32) {
        // Follow editor order: left 1→2→3→4; right reverses. One step per gesture.
        var step = gesture.dx < 0 ? 1 : -1;
        selectScene((gesture.start + step + scenes.length) % scenes.length, true);
        suppressClickUntil = Date.now() + 700;
      }
      gesture = null;
    }
    if (mobileSurface) {
      mobileSurface.addEventListener('touchstart', function (e) { lastTouchAt = Date.now(); if (isMobileMode() && e.touches.length === 1) swipeStart(e.touches[0].clientX, e.touches[0].clientY); else gesture = null; }, { passive: true, signal: signal });
      mobileSurface.addEventListener('touchmove', function (e) { if (e.touches.length === 1) swipeMove(e.touches[0].clientX, e.touches[0].clientY, e); else gesture = null; }, { passive: false, signal: signal });
      mobileSurface.addEventListener('touchend', swipeEnd, { passive: false, signal: signal });
      mobileSurface.addEventListener('touchcancel', function () { gesture = null; }, { signal: signal });
      mobileSurface.addEventListener('pointerdown', function (e) { if (isMobileMode() && e.pointerType !== 'touch' && e.isPrimary && e.button === 0 && Date.now() - lastTouchAt > 800) { swipeStart(e.clientX, e.clientY); mobileSurface.setPointerCapture(e.pointerId); } }, { signal: signal });
      mobileSurface.addEventListener('pointermove', function (e) { if (e.pointerType !== 'touch') swipeMove(e.clientX, e.clientY, e); }, { signal: signal });
      mobileSurface.addEventListener('pointerup', function (e) { if (e.pointerType !== 'touch') { swipeEnd(); if (mobileSurface.hasPointerCapture(e.pointerId)) mobileSurface.releasePointerCapture(e.pointerId); } }, { signal: signal });
      mobileSurface.addEventListener('pointercancel', function () { gesture = null; }, { signal: signal });
    }
    section.addEventListener('shopify:block:select', function (event) {var id=event.detail&&event.detail.blockId;var index=scenes.findIndex(function(scene){return scene.blockId===id;});if(index>=0)selectScene(index,true);},{signal:signal});
    wheel.addEventListener('keydown', function (event) {
      var next = null;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = Math.round(target) + 1;
      else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = Math.round(target) - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = scenes.length - 1;
      if (next === null) return;
      event.preventDefault();
      selectScene(next, true);
      if (event.target.classList.contains('scene-btn')) list.children[Math.round(target)].focus({ preventScroll: true });
    }, { signal: signal });
    window.addEventListener('resize', function () { measureScroll(); start(); keepActiveVisible(Math.round(target)); }, { signal: signal });
    mobileQuery.addEventListener('change', function () { refreshSources(); measureScroll(); start(); keepActiveVisible(Math.round(target)); }, { signal: signal });
    motionQuery.addEventListener('change', function () { reduceMotion = motionQuery.matches; scheduleScroll(); start(); }, { signal: signal });

    if (scrollDriven) {
      window.addEventListener('scroll', scheduleScroll, { passive: true, signal: signal });
      if (window.ResizeObserver) { sizeObserver = new ResizeObserver(measureScroll); sizeObserver.observe(scrollStage); }
      function preloadScenes() { scenes.forEach(function (scene, index) { requestImage(index); }); }
      if (window.IntersectionObserver) {
        preloadObserver = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) { preloadScenes(); preloadObserver.disconnect(); }
        }, { rootMargin: '100% 0px' });
        preloadObserver.observe(scrollRoot);
      } else preloadScenes();
      measureScroll();
    }
    rowSize = rowHeight();
    if (document.fonts) document.fonts.ready.then(function () { if (!disposed) { measureScroll(); start(); } });

    // Preview editor updates the source of a stable scene, not just the
    // currently visible layer. Scroll changes keep the replacement intact.
    section.sceneGetImage = function (index) { return scenes[index] && sourceFor(scenes[index]); };
    section.sceneSetImage = function (index, source) {
      if (!scenes[index] || disposed) return;
      scenes[index].desktopSource = source;
      scenes[index].source = sourceFor(scenes[index]);
      wheel.setAttribute('data-scene-image-' + (index + 1), source);
      ready[index] = false;
      requested[index] = false;
      requestImage(index);
      start();
    };

    section.sceneCleanup = function () {
      disposed = true;
      controller.abort();
      window.cancelAnimationFrame(raf);
      window.clearTimeout(timer);
      if (sizeObserver) sizeObserver.disconnect();
      if (preloadObserver) preloadObserver.disconnect();
      if (scrollRoot) {
        scrollRoot.classList.remove('is-ready');
        scrollRoot.style.removeProperty('--m02-scroll-height');
        scrollRoot.removeAttribute('data-scroll-step-px');
        scrollRoot.removeAttribute('data-active-scene');
        scrollRoot.removeAttribute('data-scene-progress');
      }
      section.querySelectorAll('.scene-image-layer--secondary').forEach(function (node) { node.remove(); });
      image.classList.remove('scene-image-layer');
      if (originalSource !== null) image.setAttribute('src', originalSource);
      if (originalStyle === null) image.removeAttribute('style');
      else image.setAttribute('style', originalStyle);
      if (originalAlt === null) image.removeAttribute('alt');
      else image.setAttribute('alt', originalAlt);
      list.replaceChildren();
      delete section.sceneGetImage;
      delete section.sceneSetImage;
      delete section.sceneCleanup;
    };
    refreshSources();
    apply(0, true);
  }

  function forScenes(scope, action) {
    if (scope.matches && scope.matches('.scene-section')) action(scope);
    scope.querySelectorAll('.scene-section').forEach(action);
  }

  function initAll(scope) { forScenes(scope, initScene); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    forScenes(event.target, function (section) { if (section.sceneCleanup) section.sceneCleanup(); });
  });
}());


